import { useCarousel, UseCarouselParams, UseCarouselReturn } from '@hooks/useCarousel';
import noop from 'lodash/noop';
import * as React from 'react';

export type CarouselProviderProps = UseCarouselParams;

const CarouselContext = React.createContext<UseCarouselReturn>({
  activeIndex: 0,
  goToIndex: noop,
  goToNext: noop,
  goToPrev: noop,
  reinitialise: noop,
  maxIndex: 0,
  offset: 0,
  offsets: [],
  recalculate: noop,
  refContainer: null,
  refTrack: null,
  count: 0,
  paddingOffset: 0,
  pageChildren: 1,
});

export const useCarouselContext = (): UseCarouselReturn => React.useContext(CarouselContext);

const CarouselProvider: React.FC<CarouselProviderProps> = ({ children, ...otherProps }) => {
  const carousel = useCarousel(otherProps);

  React.useEffect(() => {
    if (carousel.paddingOffset !== otherProps.paddingOffset) {
      carousel.reinitialise(carousel.count, otherProps.paddingOffset);
    }
  }, [otherProps.paddingOffset]);

  React.useEffect(() => {
    if (carousel.count !== otherProps.count) {
      carousel.reinitialise(otherProps.count, carousel.paddingOffset);
    }
  }, [otherProps.count]);

  return <CarouselContext.Provider value={carousel}>{children}</CarouselContext.Provider>;
};

export default CarouselProvider;
